import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Kit, Profile, KitStatus } from '../../models/customerOverview';
import { KitOverviewResponse } from '../../containers/Customers/component/Dial';

export enum CustomerOverviewActionTypes {
  CLEAR_SEARCH_PARAMETERS = 'CLEAR_SEARCH_PARAMETERS',
  START_FETCHING_KITS = 'START_FETCHING_KITS',
  FETCH_KITS_SUCCESS = 'FETCH_KITS_SUCCESS',
  FETCH_PROFILES_SUCCESS = 'FETCH_PROFILE_SUCCESS',
  FETCH_KITS_BY_STATUS = 'FETCH_KITS_BY_STATUS',
  SET_TABLE_PAGE = 'SET_TABLE_PAGE',
  SET_TABLE_SEARCH_TERM = 'SET_TABLE_SEARCH_TERM',
  SET_KIT_STATUS_OVERVIEW_SUCCESS = 'SET_KIT_STATUS_OVERVIEW_SUCCESS',
}

export interface ActionClearSearchParameters extends Action {
  type: CustomerOverviewActionTypes.CLEAR_SEARCH_PARAMETERS;
}

export interface ActionFetchKits extends Action {
  type: CustomerOverviewActionTypes.START_FETCHING_KITS;
}

export interface ActionFetchKitsSuccess extends Action {
  type: CustomerOverviewActionTypes.FETCH_KITS_SUCCESS;
  payload: {
    kits: Kit[];
    total: string | number;
  };
}

export interface ActionFetchKitOverViewSuccess extends Action {
  type: CustomerOverviewActionTypes.SET_KIT_STATUS_OVERVIEW_SUCCESS;
  payload: KitOverviewResponse;

}
export interface ActionFetchProfilesSuccess extends Action {
  type: CustomerOverviewActionTypes.FETCH_PROFILES_SUCCESS;
  payload: Profile[];
}

export interface ActionFetchKitsByStatus extends Action {
  type: CustomerOverviewActionTypes.FETCH_KITS_BY_STATUS;
  payload: KitStatus;
}

export interface ActionSetTablePage extends Action {
  type: CustomerOverviewActionTypes.SET_TABLE_PAGE;
  payload: number;
}

export interface ActionSetTableSearchTerm extends Action {
  type: CustomerOverviewActionTypes.SET_TABLE_SEARCH_TERM;
  payload: string;
}

export type CustomerOverviewAction =
  | ActionClearSearchParameters
  | ActionFetchKits
  | ActionFetchKitsSuccess
  | ActionFetchProfilesSuccess
  | ActionFetchKitsByStatus
  | ActionSetTablePage
  | ActionSetTableSearchTerm
  | ActionFetchKitOverViewSuccess
  ;

export type CustomerThunkDispatch = ThunkDispatch<undefined, undefined, CustomerOverviewAction>;
